<template>
    <div class="container py-2 mt-4 mb-4">
        <div class="row" v-for="(state, index) in statesTracking" :key="index">
            <div class="col-auto text-center flex-column d-none d-sm-flex">
                <h5 class="m-2">
                    <i class="fas fa-check-circle fa-lg text-primary" v-if="index == 0"></i>
                    <span class="badge badge-pill bg-light border" v-else>&nbsp;</span>
                </h5>
                <div class="row h-100">
                    <div :class="['col', ((statesTracking.length - 1) == index) ? '' : 'border-right']">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col pb-2 pt-1">
                    <span class="h5 text-muted float-right">วันที่ {{ (state.datetime).split(" ")[0] | dateFormat }}</span>
                    <h4>{{state.description}}</h4>
                    <h5 class="text-muted">{{state.location}}  <span class="float-right">เวลา {{ (state.datetime).split(" ")[1] | timeFormat }}</span></h5>
                    
                    <b-button class="px-2" size="sm" 
                        variant="danger" 
                        v-if="state.hasOwnProperty('info') && state.info.hasOwnProperty('pod')"
                        @click="showModalImages(state.info.pod , `รูปลายเซ็นผู้รับ`)"
                    >
                        ดูลายเซ็น
                    </b-button>
                </div>
            </div>
            <ModalImages :data="dataModalImages"></ModalImages>
        </div>
    </div>
</template>

<script>
import ModalImages from '@/components/Modals/Modal-images'
import moment from "moment";

export default {
    name:"statesTracking",
    props:{
        statesTracking: Array
    },
    components:{
        ModalImages
    },
    data(){
        return {
            dataModalImages:{
                show:false,
                img:false,
                name:"img"
            },
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        },
        timeFormat(time) {
            return moment(time, "HH:mm:ss").format("HH:mm");
        },
    },
    methods:{
        showModalImages( img , name ){
           this.dataModalImages.show = true
           this.dataModalImages.img = img
           this.dataModalImages.name = name
        },
    },
}
</script>